<ion-item class="question-item drop-down-item" [formGroup]="form">
  <ion-label position="stacked" *ngIf="label">{{ label }}</ion-label>
  <ion-select
    [placeholder]="placeholder"
    [interface]="interface"
    [interfaceOptions]="label ? {header: label} : {}"
    [formControlName]="inputName"
    [ngClass]="{ error: isError }"
    [cancelText]="'SHARED_TEXT.CANCEL' | translate"
    [okText]="'SHARED_TEXT.OK' | translate"
    [disabled]="disabled"
    (ionChange)="valueChange.emit($event)"
  >
    <ion-select-option
      *ngFor="let item of list"
      [value]="listValueKey ? item[listValueKey] : item"
      >{{ listLabelKey ? item[listLabelKey] : item }}</ion-select-option
    >
  </ion-select>
</ion-item>
